const routeConstant = {
  home: {
    path: "/",
    title: "Home",
  },
  login: {
    path: "/login",
    title: "Login",
  },
  forgotPassword: {
    path: "/forgot-password",
    title: "Forgot Password",
  },
  resetPassword: {
    path: "/reset-password",
    title: "Reset Password",
  },
  dashboard: {
    path: "/dashboard/home",
    title: "Home",
  },
  questionaire: {
    path: "/dashboard/job-questionnaire",
    title: "Job Questionnaire",
  },
  evaluationRecord: {
    path: "/dashboard/evaluation-record",
    title: "Evaluation Record",
  },
  archiveEvaluationRecord: {
    path: "/dashboard/archive-evaluation-record",
    title: "Archived Evaluations",
  },
  evaluationRecordDetail: {
    path: "/dashboard/evaluation-record/:id",
    title: "Record Details",
  },
  cgpEvaluationRecordDetail: {
    path: "/dashboard/cgp-evaluation-record/:id",
    title: "Record Details",
  },
  editEvaluationRecord: {
    path: "/dashboard/edit-evaluation/:id",
    title: "Edit Evaluation Record",
  },
  draftEvaluation: {
    path: "/dashboard/draft-evaluation",
    title: "Draft Evaluations",
  },
  continueDraftEvaluation: {
    path: "/dashboard/draft-evaluation/:id",
    title: "Complete Evaluation",
  },
  flagEvaluation: {
    path: "/dashboard/flag-evaluation",
    title: "Flagged Evaluations",
  },
  cgpEvaluation: {
    path: "/dashboard/cgp-evaluation",
    title: "Evaluations by CGP",
  },
  reqEvaluation: {
    path: "/dashboard/req-evaluation",
    title: "Request Evaluation",
  },
  contact: {
    path: "/dashboard/contact",
    title: "Customer Support",
  },
  aboutUS: {
    path: "https://www.compgovpartners.com/about",
    title: "About Us",
  },
  contactUs: {
    path: "https://www.compgovpartners.com/contact",
    title: "Contact Us",
  },
  privacy: {
    path: "https://www.compgovpartners.com/privacy-policy",
    title: "Privacy Policy",
  },
  settings: {
    path: "/dashboard/settings",
    title: "Account",
  },
  multipleEvaluationRecordDetail: {
    path: "/dashboard/multiple-evaluations-record",
    title: "Record Details",
  },
};

export { routeConstant };
